<div fxLayout="column">
  <div fxFlex fxLayout="row" *ngIf="hasFilter" fxLayoutGap="10">
    <div fxFlex class="search-input">
      <mat-form-field *ngIf="!hideFilter">
        <input
          matInput
          #input
          (keyup)="applyFilter(filterValue)"
          [(ngModel)]="filterValue"
          (focus)="keyboardService.onInputFocus(keyboardChange, $event)"
          (onModelChange)="keyboardService.onInputChange($event, input)"
          placeholder="Pesquisar" />
      </mat-form-field>
    </div>
    <div fxFlex="initial" *ngIf="hasAdd">
      <button mat-fab class="btn-add" (click)="openNew.emit()">
        <mat-icon
          aria-label="Example icon-button with a heart icon">add</mat-icon>
      </button>
    </div>
  </div>
  <div class="mat-elevation-z8" class="mat-elevation-z8">
    <div class="table-container">
      <table mat-table [dataSource]="dataSource" multiTemplateDataRows matSort>
        <!-- Checkbox Column -->
        <ng-container *ngIf="hasSelectConfig()" matColumnDef="select" sticky>
          <th mat-header-cell *matHeaderCellDef>
            <mat-checkbox
              (click)="onCheckRow($event)"
              (change)="$event ? toggleAllRows() : null"
              [checked]="selection.hasValue() && isAllSelected()"
              [indeterminate]="selection.hasValue() && !isAllSelected()"
              [aria-label]="checkboxLabel()">
            </mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let row; let i = index">
            <mat-checkbox
              (click)="onCheckRow($event, i)"
              (change)="$event ? selection.toggle(row) : null"
              [checked]="selection.isSelected(row)"
              [aria-label]="checkboxLabel(row)">
            </mat-checkbox>
          </td>
        </ng-container>
        <!-- Position Column -->
        <ng-container
          *ngFor="let config of configColumns; let idx = index"
          matColumnDef="{{ config.property }}">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ config.display }}
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            class="{{ config.class }} td_idx_{{ idx }}"
            [attr.data-label]="config.display">
            <!-- LABELS -->
            <!-- LINK -->
            <a
              *ngIf="
                (config.field_type === fieldTypeEnum.LABEL ||
                  config.field_type === fieldTypeEnum.LABEL_CURRENCY) &&
                config.link_show
              "
              href="javascript:void()"
              (click)="openShow.emit(element)"
              class="disabled_link_on_web {{ activeShowLockClass(element) }}">
              <span *ngIf="!config.maxLength">{{ getValue(config,
                element[config.property]) }}</span>
              <span *ngIf="config.maxLength"
                [matTooltip]="(getValue(config, element[config.property])?.length || 0) > config.maxLength ? getValue(config, element[config.property]) : ''">{{
                getValue(config, element[config.property]) |
                slice:0:config.maxLength }}{{ (getValue(config,
                element[config.property])?.length || 0) > config.maxLength ?
                '...' : '' }}</span>
            </a>
            <!-- LABEL COMUM -->
            <ng-container
              *ngIf="
                (config.field_type === fieldTypeEnum.LABEL ||
                  config.field_type === fieldTypeEnum.LABEL_CURRENCY) &&
                !config.link_show
              "
              class="{{ activeShowLockClass(element) }}">
              <span *ngIf="!config.maxLength">{{ getValue(config,
                element[config.property]) }}</span>
              <span *ngIf="config.maxLength"
                [matTooltip]="(getValue(config, element[config.property])?.length || 0) > config.maxLength ? getValue(config, element[config.property]) : ''">{{
                getValue(config, element[config.property]) |
                slice:0:config.maxLength }}{{ (getValue(config,
                element[config.property])?.length || 0) > config.maxLength ?
                '...' : '' }}</span>
            </ng-container>
            <!-- LABEL FLAG -->
            <ng-container
              *ngIf="config.field_type === fieldTypeEnum.LABEL_FLAG">
              <span
                [ngClass]="{
                  'text-green': element[config.property] === 'SIM',
                  'text-red': element[config.property] === 'NÃO',
                  'text-partial': element[config.property]?.startsWith('PARCIAL'),
                  'text-loading': element[config.property] === 'LOADING',
                  'text-error': element[config.property] === 'ERRO'
                }">
                {{ element[config.property] }}
              </span>
            </ng-container>

            <ng-container *ngIf="config.field_type === fieldTypeEnum.IMAGE">
              <img
                class="image-label"
                [src]="getUrl(element[config.property])" />
            </ng-container>
          </td>
        </ng-container>

        <!-- Symbol Column -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element; let row = index">
            <button mat-icon-button (click)="viewPlans.emit(element)"
              matTooltip="Visualizar Planos">
              <mat-icon class="btn-view-plans">view_list</mat-icon>
            </button>
            <button
              *ngIf="showMoney"
              (click)="moneyAction.emit(element)"
              mat-icon-button
              class="btn-financial"
              matTooltip="Contas a Receber">
              <i class="material-icons">attach_money</i>
            </button>
            <button mat-icon-button (click)="contract.emit(element)"
              matTooltip="Visualizar Contratos">
              <mat-icon class="btn-contract">description</mat-icon>
            </button>
            <!-- Botão de DESBLOQUEAR (aparece quando isLock é false) -->

            <button mat-icon-button [matMenuTriggerFor]="menu">
              <mat-icon>more_vert</mat-icon>
            </button>
            <!-- Botões dentro do MENU -->
            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="downloadClientImage(element)" class="btn-download">
                <mat-icon class="btn-download">download</mat-icon>
                <span>Download</span>
              </button>
              <button
                *ngIf="showLock && element[lockProperty]"
                (click)="unlock.emit(element)"
                mat-menu-item
                class="btn-unlock"
                [matTooltip]="'Desbloquear' + (element.lockedAt ? ' (Bloqueado em: ' + (element.lockedAt | date:'dd/MM/yyyy HH:mm') + ')' : '')"
                [disabled]="element._lockLoading">
                <mat-icon class="btn-unlock" *ngIf="!element._lockLoading">lock_open</mat-icon>
                <span class="LabelInsideMenu">Desbloquear</span>
                <mat-progress-spinner *ngIf="element._lockLoading" diameter="20" mode="indeterminate" color="primary" style="display:inline-block;vertical-align:middle;"></mat-progress-spinner>
              </button>
              <!-- Botão de BLOQUEAR (aparece quando isLock é true) -->
              <button
                *ngIf="showLock && !element[lockProperty]"
                (click)="lock.emit(element)"
                mat-menu-item
                class="btn-lock"
                [matTooltip]="'Bloquear' + (element.unlockedAt ? ' (Desbloqueado em: ' + (element.unlockedAt | date:'dd/MM/yyyy HH:mm') + ')' : '')"
                [disabled]="element._lockLoading">
                <mat-icon class="btn-lock" *ngIf="!element._lockLoading">lock</mat-icon>
                <span class="LabelInsideMenu">Bloquear</span>
                <mat-progress-spinner *ngIf="element._lockLoading" diameter="20" mode="indeterminate" color="primary" style="display:inline-block;vertical-align:middle;"></mat-progress-spinner>
              </button>


              <button
                *ngIf="showPeopleLock && element[lockPeopleProperty]"
                (click)="lockPeople.emit(element)"
                mat-menu-item
                
                >
                <mat-icon class="btn-lock">people</mat-icon>
                <span class="LabelInsideMenu">Bloquear Pessoa</span>
              </button>

              <button
                *ngIf="showActive && element[activeProperty]"
                (click)="inactive.emit(element)"
                mat-menu-item
                class="btn-inactive"
                >
                <mat-icon class="btn-inactive">remove_circle</mat-icon>
                <span class="LabelInsideMenu">Desativar</span>
              </button>
              <button
                *ngIf="showActive && !element[activeProperty]"
                (click)="active.emit(element)"
                mat-menu-item
                
                >
                <mat-icon class="btn-active">check_circle</mat-icon>
                <span class="LabelInsideMenu">Ativar</span>
              </button>

              <button
                *ngIf="showPeopleLock && !element[lockPeopleProperty]"
                (click)="unlockPeople.emit(element)"
                mat-menu-item
                class="btn-unlock"
                >
                <mat-icon class="btn-unlock">people</mat-icon>
                <span >Desbloquear Pessoa</span>
              </button>

              <button
                *ngIf="showKey"
                (click)="key.emit(element)"
                mat-menu-item
                class="btn-key"
                >
                <mat-icon class="btn-key">vpn_key</mat-icon>
                <span class="LabelInsideMenu">Resetar a Senha</span>
              </button>
              <button
                *ngIf="showDocumentPhoto"
                (click)="DocumentPhoto.emit(element)"
                mat-menu-item
                class="btn-lock"
                >
                <mat-icon class="btn-lock">camera_alt</mat-icon>
                <span>Foto do Documento</span>
             </button>
              <button mat-menu-item *ngIf="!element.hideShow" (click)="showRow(element, row)">
                <mat-icon class="btn-show">
                  remove_red_eye
                </mat-icon>
                <span class="LabelInsideMenu">Visualizar</span>
              </button>
              <button mat-menu-item *ngIf="!element.hideEdit && isEditableShow"
                [disabled]="!isEditableEnabled" (click)="isEditableEnabled && editRow(element, row)">
                <mat-icon
                  [ngClass]="isEditableEnabled ? 'btn-edit' : 'btn-edit:disabled'">edit</mat-icon>
                  <span class="LabelInsideMenu">Editar</span>
              </button>
            </mat-menu>

            <!-- <button mat-icon-button
              *ngIf="!element.hideDelete && isDeletableShow"
              [disabled]="isDeletableEnabled">
              <mat-icon
                [ngClass]="isDeletableEnabled ? 'btn-delete' : 'btn-delete:disabled'"
                (click)="isDeletableEnabled && deleteRow(element, row)">delete</mat-icon>
            </button> -->
          </td>
        </ng-container>

        <ng-container matColumnDef="expand">
          <th mat-header-cell *matHeaderCellDef aria-label="row actions">
            &nbsp;
          </th>
          <td mat-cell *matCellDef="let element">
            <button
              mat-icon-button
              aria-label="expand row"
              (click)="
                expandedElement = expandedElement === element ? null : element;
                $event.stopPropagation()
              ">
              <mat-icon
                *ngIf="expandedElement !== element">keyboard_arrow_down</mat-icon>
              <mat-icon
                *ngIf="expandedElement === element">keyboard_arrow_up</mat-icon>
            </button>
          </td>
        </ng-container>

        <!-- <ng-container matColumnDef="expandedDetail">
          <td
            mat-cell
            *matCellDef="let element"
            [attr.colspan]="displayedColumns.length">
            <div
              class="example-element-detail"
              [@detailExpand]="
                element == expandedElement ? 'expanded' : 'collapsed'
              ">
              <ng-template
                *ngTemplateOutlet="templateRef; context: { rawData: element }"></ng-template>
            </div>
          </td>
        </ng-container> -->

        <tr
          mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          (click)="onSelect.emit({ select: true, row })"
          [ngClass]="
            typeIndexEnum.SELECT === type ? 'cursor-pointer' : 'cursor-normal'
          "></tr>
        <!-- <tr
          mat-row
          *matRowDef="let row; columns: ['expandedDetail']"
          class="example-detail-row"></tr> -->
      </table>
    </div>

    <mat-paginator
      *ngIf="!hidePagination"
      [length]="length"
      [pageSize]="pageSize"
      [pageSizeOptions]="pageSizeOptions"
      (page)="pageEvent($event)"></mat-paginator>

    <app-customer-table-totalizers
      [totalizers]="totalizers"
      [length]="length"></app-customer-table-totalizers>
  </div>
</div>
